import {
	isContractor,
	nullSafeGet,
	nullSafeGetOrElse,
	recordHasContractorId,
} from '../../utils/DataAccessUtils';
import * as React from 'react';
import { withRouter } from 'react-router';
import { withUserType } from '../withUserType';
import { connect } from 'react-redux';

const ViewPastRevisionsButton = ({ record, recordType = 'invoice', userType, currentUser }) => {
	const hasContractorId = recordHasContractorId(record);
	const isClientView = !isContractor(currentUser, record);

	const subUrl = `/${userType}/${recordType}s${
		hasContractorId ? (isClientView ? '/contractor' : '/subcontractor') : ''
	}/`;
	return (
		nullSafeGetOrElse('revisionChanges.length', record, 0) > 1 && (
			<span style={{ marginLeft: '12px' }}>
				<a
					style={{ textDecoration: 'underline', color: 'rgba(0, 0, 0, 0.65)' }}
					href={`${subUrl}detail/${nullSafeGet('id', record)}/revisions`}
					target={'_blank'}
				>
					View past revisions
					<i className="icons8-font icons8-external-link ml-2 inline-block" />
				</a>
			</span>
		)
	);
};

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch, ownProps) => ({});

export default withRouter(
	withUserType(connect(mapStateToProps, mapDispatchToProps)(ViewPastRevisionsButton))
);
